// extracted by mini-css-extract-plugin
module.exports = {"Image":"empty_Image__hM_Zi","Text":"empty_Text__uJxji"};